import React from 'react';
import { observer } from 'mobx-react-lite';
import { BonusCreationState } from 'src/domains/casino/webview/bonus-engine/bonus-creator/bonus-creation/BonusCreation.state';
import { CampaignCreatorState } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.state';
import { MultiSelectList } from 'src/domains/common/components/multi-select-list/multi-select-list';

interface FreeSpinsPickerPropsType {
    state: BonusCreationState | CampaignCreatorState;
    disabled?: boolean;
    errors: string[];
}

export const FreeSpinsPicker = observer((props: FreeSpinsPickerPropsType): JSX.Element => {
    const freeSpinsEligibleGamesState =
        props.state.rewardConditionsState.casinoSectionState.freeSpinsEligibleGamesState;

    const {
        showAllBadges,
        expanded,
        visibleCheckedWithLabels,
        visibleChecked,
        filteredNodes,
        keywordInputState,
        checked,
        toggleShowAllBadges,
        clearChecked,
        handleCheck,
        handleExpand,
        setKeyword,
        handleRemoveChecked,
    } = freeSpinsEligibleGamesState;
    return (
        <div className='flex flex-col gap-2'>
            <label className='text-sm'>Free Spins Eligible Games</label>
            <MultiSelectList
                filteredNodes={filteredNodes}
                showAllBadges={showAllBadges}
                checked={checked}
                errors={props.errors}
                visibleChecked={visibleChecked}
                keywordInputState={keywordInputState}
                expanded={expanded}
                visibleCheckedWithLabels={visibleCheckedWithLabels}
                toggleShowAllBadges={toggleShowAllBadges}
                clearChecked={clearChecked}
                handleCheck={handleCheck}
                handleExpand={handleExpand}
                setKeyword={setKeyword}
                handleRemoveChecked={handleRemoveChecked}
                remaining={visibleChecked.remaining}
                remainingLabel='Items'
                disabled={props.disabled}
            />
        </div>
    );
});
